module.exports = __webpack_public_path__ + "static/media/ascentarc-5.59ea545d.jpg";